// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/back2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.app,
.content {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "Source Sans Pro", sans-serif;
  
}

.app {
  display: flex;
  position: relative;
}

.default-dg{
  width: 100%;
  height: 100%;
}


.login-div{
  width: 20%;
  height: 40%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(1, 9, 31, 0.8);
  box-shadow: 0 0 35px 1px white;
  border-radius: 10px;
  
}

.loging-bg{
  width:100%;
  height:100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.login-title{
  margin-top: 20%;
  /* font-size: 30%; */
  font-size: 1.3vw;
  color: white;
}

.form{
  width: 80%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.login-id-tv{
  width: 95%;
  height: 5vh;
  border-radius: 40px;
  border: none;
  box-shadow: 0 0 0 2px rgb(172, 172, 172,0.3);
  background-color: rgba(1, 9, 31, 0);
  
  font-size: 13px;
  color: rgba(238, 238, 238, 0.8);

  padding: 0 10px;
}


.login-pw-tv{
  width: 95%;
  height: 5vh;
  border-radius: 40px;
  border: none;
  box-shadow: 0 0 0 2px rgb(172, 172, 172,0.3);
  background-color: rgba(1, 9, 31, 0);
  
  margin-top: 15px;
  font-size: 13px;
  color: white;

  padding: 0 10px;
}

/*input text 브라우저 별 힌트 텍스트 칼라*/
input::placeholder {
  color:rgba(238, 238, 238, 0.7);
  font-weight: bold;
  font-size: 12px;
}
input::-webkit-input-placeholder {
  color:rgba(238, 238, 238, 0.7);
  font-weight: bold;
  font-size: 12px;
}
input:-ms-input-placeholder {
  color:rgba(238, 238, 238, 0.7);
  font-weight: bold;
  font-size: 12px;
}

.login-id-tv:focus{
  outline: none;
}

.login-pw-tv:focus{
  outline: none;
}

.login-btn{
  width: 100%;
  height: 3vh;
  color: rgb(112, 112, 112);
  border-radius: 15px;
  border: 0;
  font-weight: bold;
}

::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #e0e0e0;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* .react-datepicker-wrapper {
  display: none !important;
} */

.react-datepicker-popper {
  z-index: 9999 !important;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;;EAKE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,0CAA0C;;AAE5C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;;AAErB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yDAA0C;EAC1C,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,mCAAmC;;EAEnC,eAAe;EACf,+BAA+B;;EAE/B,eAAe;AACjB;;;AAGA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,mCAAmC;;EAEnC,gBAAgB;EAChB,eAAe;EACf,YAAY;;EAEZ,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;AAC1B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap\");\n\nhtml,\nbody,\n#root,\n.app,\n.content {\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  font-family: \"Source Sans Pro\", sans-serif;\n  \n}\n\n.app {\n  display: flex;\n  position: relative;\n}\n\n.default-dg{\n  width: 100%;\n  height: 100%;\n}\n\n\n.login-div{\n  width: 20%;\n  height: 40%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  background: rgba(1, 9, 31, 0.8);\n  box-shadow: 0 0 35px 1px white;\n  border-radius: 10px;\n  \n}\n\n.loging-bg{\n  width:100%;\n  height:100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url(../public/back2.png);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.login-title{\n  margin-top: 20%;\n  /* font-size: 30%; */\n  font-size: 1.3vw;\n  color: white;\n}\n\n.form{\n  width: 80%;\n  height: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.login-id-tv{\n  width: 95%;\n  height: 5vh;\n  border-radius: 40px;\n  border: none;\n  box-shadow: 0 0 0 2px rgb(172, 172, 172,0.3);\n  background-color: rgba(1, 9, 31, 0);\n  \n  font-size: 13px;\n  color: rgba(238, 238, 238, 0.8);\n\n  padding: 0 10px;\n}\n\n\n.login-pw-tv{\n  width: 95%;\n  height: 5vh;\n  border-radius: 40px;\n  border: none;\n  box-shadow: 0 0 0 2px rgb(172, 172, 172,0.3);\n  background-color: rgba(1, 9, 31, 0);\n  \n  margin-top: 15px;\n  font-size: 13px;\n  color: white;\n\n  padding: 0 10px;\n}\n\n/*input text 브라우저 별 힌트 텍스트 칼라*/\ninput::placeholder {\n  color:rgba(238, 238, 238, 0.7);\n  font-weight: bold;\n  font-size: 12px;\n}\ninput::-webkit-input-placeholder {\n  color:rgba(238, 238, 238, 0.7);\n  font-weight: bold;\n  font-size: 12px;\n}\ninput:-ms-input-placeholder {\n  color:rgba(238, 238, 238, 0.7);\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.login-id-tv:focus{\n  outline: none;\n}\n\n.login-pw-tv:focus{\n  outline: none;\n}\n\n.login-btn{\n  width: 100%;\n  height: 3vh;\n  color: rgb(112, 112, 112);\n  border-radius: 15px;\n  border: 0;\n  font-weight: bold;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #e0e0e0;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* .react-datepicker-wrapper {\n  display: none !important;\n} */\n\n.react-datepicker-popper {\n  z-index: 9999 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
